import { Injectable } from '@angular/core';
import {   HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let patientCancelUrl = CONFIG.baseUrls.patCancel;

export interface PatCancel {

    patCode: number;
    cancelRes?: number;
    fullNameAr?: string;
    fullNameEn?: string;
    identityType?: number;
    identityValue?: string;
}
@Injectable()
export class PatientCancelService {

    constructor(private httpGeneralService: HttpGeneralService) {
        //this._messageService.state.subscribe();
    }
    /////////////////////////////////////////////////#ibra patient cancel
    cancelPatient(patCancel: PatCancel) {

        return this.httpGeneralService.post(patCancel, `${patientCancelUrl}`);

        //let body = JSON.stringify(patCancel);
        //var headers = new Headers();
        //headers.append('Content-Type', 'application/json');
        //this._spinnerService.show();
        //return this._http
        //    .post(`${patientCancelUrl}`, body, { headers: headers })
        //    .map(res => <Message>res.json())
        //    .catch(this._exceptionService.catchBadResponse)
        //    .finally(() => this._spinnerService.hide());
    }
}

